import React, { useEffect } from 'react';
import './App.css';
import { Layout, Skeleton, Space } from 'antd';
import { Route, Routes, useLocation, useNavigate } from "react-router-dom";
import LoginPage from './pages/login-page';
import IntroPage from './pages/intro-page';
import logo from './logo.png'
import UserHomePage from './pages/user-home-page';
import ScenarioHostPage from './pages/scenario-host-page';
import AuthService, { user$ } from './services/auth-service';
import { GetCurrentUserResponse } from './request-response/get-current-user-response';
import { UserModel } from './models/user-model';
import { useObservable } from 'rxjs-hooks';
import UsersPage from './pages/users-page';
import ScenariaAdminPage from './pages/scenaria-admin-page';
import Echo from 'laravel-echo';
import Pusher from 'pusher-js';
import { LogoutOutlined, UserOutlined } from '@ant-design/icons';
import UsersListPage from './pages/users-list-page';
import ScenariaListPage from './pages/scenaria-list-page';
import ScenarioPage from './pages/scneario-page';
import dayjs from 'dayjs';

declare global {
  interface Window {
      Pusher: typeof Pusher; 
      Echo: Echo<'reverb'>; 
  }
}


function App() {
  let location = useLocation();
  const navigate = useNavigate();
  const currentUser : UserModel|undefined = useObservable(user$, undefined);
  


  window.Pusher = Pusher;
  //window.Pusher.logToConsole=true;
  window.Echo = new Echo({
    broadcaster:'reverb',
    key:"mmc0beux5c9ulx66ibng",
    wsHost: `${document.location.host}`, // just the host
    wsPort: `${document.location.port}/ws`, // this is a trick
    wssPort: `${document.location.port}/ws`,
    forceTLS: false,
    enabledTransports: ['ws', 'wss'],
    authEndpoint:`/broadcasting/auth`
  });

  


  useEffect(()=> {
    AuthService.getInstance().getCurrentUserFromServer().subscribe({
      next: (response:GetCurrentUserResponse)=>{

      }
    });
  },[]);

  return (
      <Layout>
      <Layout.Header className="hipaheader">
        <div>
          <a onClick={()=>navigate("/")}>
            <img src={logo} alt="logo" height="130"/>
          </a>
        </div>
        <h1 style={{marginLeft:10,width:265,whiteSpace:'pre-wrap',lineHeight:'30px'}}>Insightful Decision Support for Airborne Emissions</h1>
        <div style={{flex:"1 auto"}}></div>
        {currentUser && <Space>
          <UserOutlined onClick={()=>navigate("/user-home")} style={{fontSize:20}}/>
          <LogoutOutlined style={{fontSize:20}} onClick={()=>{
            window.Echo.leaveAllChannels();
            AuthService.getInstance().logout().subscribe({complete:()=>{
              navigate("/");
            }})
          }} />
        </Space>}
      </Layout.Header>
      <Layout.Content className='hipacontent'>
        <div className="inner-content">
          <Routes>
            <Route path="/" element={<IntroPage/>}/>
            <Route path="/login" element={<LoginPage/>}/>
            <Route path="/user-home" element={currentUser ? <UserHomePage/> : <Skeleton/>}/>
            <Route path="/users" element={(currentUser && AuthService.getInstance().getIsCurrentUserAdmin()) ? <UsersPage/>: <Skeleton/>}/>
            <Route path="/scenaria-player" element={currentUser ? <ScenariaListPage/>: <Skeleton/>}/>
            <Route path="/scenaria/:scenarioId" element={currentUser ? <ScenarioPage/>: <Skeleton/>}/>
            <Route path="/scenaria-admin" element={(currentUser && currentUser.roles.find(r=>r.name ==='admin')) ? <ScenariaAdminPage/>: <Skeleton/>}/>
            <Route path="/users-list" element={(currentUser && currentUser.roles.find(r=>r.name ==='admin')) ? <UsersListPage/>: <Skeleton/>}/>
            
            
          </Routes>
        </div>
      </Layout.Content>
      <Layout.Footer className='hipafooter'>TAMUQ&copy; {dayjs().year()}</Layout.Footer>
    </Layout>
    
  );
}

export default App;
